enum FileExtension {
	JPEG = 'JPEG',
	GIF = 'GIF',
	ZIP = 'zip',
	PDF = 'pdf',
	TXT = 'txt',
	JPG = 'jpg',
	PNG = 'png',
}

export default FileExtension;